import { RawActivationData } from "../material-ui/HistoryDialog";
import { SystemsData } from "../material-ui/SystemsContext";

export class FileResources {

  public static async getFile(path: string) {
    let responseObj: string = '';
    await fetch(path)
    .then(response => response.text())
    .then(data => responseObj = data);
    return responseObj;
  }

  public static async getContentsForFiles(filePaths: string[]) {
    const filePromises: Promise<string>[] = [];

    filePaths.forEach((path) => {
      filePromises.push(FileResources.getFile(path));
  
    });
  
    let fileContents: string[] = [];
    await Promise.all(filePromises).then((fileTextItems) => {
      fileTextItems.forEach((item) => {        
        fileContents.push(item);
      });
    });
    return fileContents;
  }

}

export class Utilities {

  public static nameof = <T>(name: keyof T) => name;
  // note: this is required because `dealId` and `email` may contain '/'
  // and other characters not permitted in a URI
  public static encodeParamForURI = function(text: string | undefined) {
    if (text) {
      return encodeURIComponent(text);
    } else {
      return '';
    }
  }

  public static daysLeft = function (expiryDateString: string) {
    //Get 1 day in milliseconds
    var one_day = 1000 * 60 * 60 * 24;

    // Convert both dates to milliseconds
    var expiryDate = Date.parse(expiryDateString);
    var currentDate = new Date();
    // Reset time part of Date() so that we only deal with dates without time element
    currentDate.setHours(0, 0, 0, 0);
    var currentDateMillis = currentDate.getTime();

    // Calculate the difference in milliseconds
    var difference_ms = expiryDate - currentDateMillis;

    // Convert back to days and return
    return Math.round(difference_ms / one_day);
  }

  public static hasExpired = function (expiryDateString: string) {
    return Utilities.daysLeft(expiryDateString) < 0;
  }

  public static expiresInNumberOfDays = function (expiryDateString: string, numberOfDays: number) {
    return Utilities.daysLeft(expiryDateString) < numberOfDays;
  }

  public static getFullId(dealId: string, lineId: string) {
    return dealId + ' ' + lineId;
  }

  public static compareRawActivation(a: RawActivationData, b: RawActivationData) {
    if (a.audit_time && b.audit_time) {
      const parsedDateA = Date.parse(a.audit_time);
      const parsedDateB = Date.parse(b.audit_time);
  
      if (parsedDateA > parsedDateB) {
        return -1;
      }
      if (parsedDateA < parsedDateB) {
        return 1;
      }
      return 0;
    }
    return 0
  }

  public static compareSystem(a: SystemsData, b: SystemsData) {
    if (a.lastModified && b.lastModified) {
      const parsedDateA = Date.parse(a.lastModified);
      const parsedDateB = Date.parse(b.lastModified);
  
      if (parsedDateA > parsedDateB) {
        return -1;
      }
      if (parsedDateA < parsedDateB) {
        return 1;
      }
      return 0;
    }
    return 0
  }

  public static validateNonEmptyText = (text: string) => {
    let isValid = false;
    if (text && text.trim() !== "" && !/^-/.test(text)) {
      isValid = true;
    }
    return isValid;
  }
  
  public static getReadableFileSizeString(file: File | null) {
    if (file === null) {
      return '0 KB';
    }
    let fileSizeInBytes = file.size;
    var i = -1;
    var byteUnits = [' KB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
      fileSizeInBytes = fileSizeInBytes / 1024;
      i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
  };

public static emptyFile = 'File is empty';
public static fileUploadSuccessful = "File upload successful";
}